"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _v = _interopRequireDefault(require("uuid/v1"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ChecklistItem extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false
    });
    _defineProperty(this, "handleChange", event => {
      event.stopPropagation();
      event.preventDefault();
      this.setState({
        loading: true
      });
      return this.props.isChecked ? this.props.onUncheck().then(() => this.setState({
        loading: false
      })).catch(() => this.setState({
        loading: false
      })) : this.props.onCheck().then(() => this.setState({
        loading: false
      })).catch(() => this.setState({
        loading: false
      }));
    });
  }
  render() {
    const uuid = (0, _v.default)();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-checkbox"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      className: 'custom-control-input' + (this.state.loading ? ' loading' : ''),
      id: uuid,
      checked: this.props.isChecked,
      onChange: this.handleChange
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label",
      htmlFor: uuid
    }, this.props.displayName));
  }
}
var _default = exports.default = ChecklistItem;
module.exports = exports.default;